const calpak = window.calpak

// if (window.debug) console.log("quick-view.js loaded");

function getQuickViewProduct(link, variant) {
  return new Promise((resolve) => {
    fetch(link + "?view=quick-view")
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        });
  });
}

function setQuickViewContent(data, variant, qvParent) {
  let innerHTML = data.layout

  // ADA pause gifs for reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    innerHTML = innerHTML.replace(/\.gif\?/g, '.gif?format=jpg&')
  }
  qvParent.querySelector(".qv__body-inner").innerHTML = innerHTML;

  const target = qvParent.querySelector(".pdp__variants");
  const product = data.product;

  // let meta = false;
  // const qvMetaJSON = qvParent.querySelector(".qv-meta-json");
  // if (qvMetaJSON)
  //   try {
  //     meta = JSON.parse(qvMetaJSON.innerHTML);
  //   } catch (e) {
  //     console.log("No QV meta!");
  //   }

  // setProductData(product, meta, target, variant);
  calpak.setProductData(product, target, variant);

  const productForm = qvParent.querySelector(".shopify-product-form");
  if (productForm)
    productForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      calpak.pdpFormSubmit(productForm, true);
    });

  // let countdown_ticks = qvParent.querySelectorAll('.countdown-timer');

  // if(countdown_ticks.length) {
  //     updateTimeouts(countdown_ticks);
  //     setInterval(() => updateTimeouts(countdown_ticks), 1000);
  // }

  const videoWithCDNs = qvParent.querySelectorAll("video");
  videoWithCDNs.forEach((video) => {
    const tracks = video.textTracks;

    for (let i = 0; i < tracks.length; i++) {
        tracks[i].mode = 'hidden';
    }

    if (window.innerWidth <= 900) {
      video.controls = false; // Hide controls by default

      video.addEventListener("click", () => {
        if (video.controls) {
          video.controls = false; // Hide controls if already showing
        } else {
          video.controls = true; // Show controls when clicked
        }
      });

      video.addEventListener("blur", () => {
        video.controls = false; // Hide controls when the video loses focus
      });
    }
  });

  const videos = qvParent.querySelectorAll(".video-iframe-container");
  if (calpak.videoObserver && videos.length)
    videos.forEach((video) => calpak.videoObserver.observe(video));

  const gallerySlider = qvParent.querySelector(".qv__gallery-inner");
  const galleryThumbsSldier = qvParent.querySelector(
      ".qv__gallery-thumbs-inner"
  );

  let variantSizeEl = qvParent.querySelector(
      ".pdp__variants .pdp__variant-size"
  );
  if (variantSizeEl) calpak.selectLoad(true, product.handle);

  calpak.variantUpdateProcess(target);
  calpak.bindWaitlist(qvParent);

  setTimeout(() => {
    calpak.checkSlider(galleryThumbsSldier, 1);
    calpak.checkSlider(gallerySlider, 1, (index) => {
      if (index == 0) return 0;
      return index - 1;
    });

    galleryThumbsSldier.addEventListener("click", (e) => {
      if (e.target.classList.contains("slide"))
        calpak.sliderThumbClick(
            e.target,
            (index) => {
              if (index == 0) return 0;
              return index + 1;
            },
            1
        );
    });
    trappingKeyboardFocus();

    // these functions don't always exist
    if (typeof customRadioButtons != 'undefined') customRadioButtons();
    if (typeof qvRatingADA != 'undefined') qvRatingADA();
  }, 1);

  // ADA custom radio JS solution
  function customRadioButtonsQV() {
    const swatchesKeyContainerUnit = document.querySelectorAll(
        ".qv__body .pdp__swatches-group > .pdp__swatches"
    );
    [].map.call(swatchesKeyContainerUnit, (container) => {
      calpak.customRadioKeyboardNav(container);
    });
  }

  setTimeout(() => {
    customRadioButtonsQV();
  }, 500);
  // End ADA custom radio JS solution

  function trappingKeyboardFocus() {
    const closeButton = document.querySelector(".qv__close");
    const qvBody = document.querySelector(".qv__body");
    const qvOverlay = document.querySelector(".qv__overlay");
    qvBody?.addEventListener("keydown", function (e) {
      const firstFocusableElement = closeButton;
      const lastFocusableElement = qvBody.querySelector(
          ".qv__full-details-link"
      );

      if (e.key == "Escape") {
        e.preventDefault();
        closeButton.click();
      }
      if (e.target === firstFocusableElement && e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement?.focus();
      }
      if (e.target === lastFocusableElement && e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement?.focus();
      }
    });

    qvOverlay.addEventListener("click", function (e) {
      e.preventDefault();
      closeButton?.click();
    });
  }

  /*const qvRatingADA = () => {
      [...document.querySelectorAll('.star-icon')].map(star => star.insertAdjacentHTML("afterend", "<span class='visually-hidden'>Star icon for rating</span>"));
      [...document.querySelectorAll('.star-background')].map(star => star.insertAdjacentHTML("afterend", "<span class='visually-hidden'>Rating of product is 5 out of 5 stars</span>"));
    }*/

  if (document.querySelector(".quick-view__container .product-label--pushoutsale-main")) {
    var pushoutsaleMainDiv = document.querySelector(
        ".quick-view__container .product-label--pushoutsale-main"
    );
    var badgeWrap = pushoutsaleMainDiv.querySelector(".badge-wrap");
    var text = badgeWrap.offsetWidth + 9;
    pushoutsaleMainDiv.style.width = text + "px";
  }

  // Extend — Dispatch window event quickViewOpened and send variant
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('quickViewOpened', { detail: data }));
  }, 1000)

  calpak.initPromoCodeCopy();

}

const getQuickView = async function(link, variant = false) {
  let qvParent = document.querySelector(".quick-view__container");
  if (!qvParent) {
    qvParent = document.createElement("div");
    qvParent.classList.add("quick-view__container");
    qvParent.setAttribute("aria-label", "Product quick view modal");
    qvParent.setAttribute("aria-modal", "true");
    qvParent.setAttribute("role", "dialog");

    qvParent.innerHTML = `<div class="qv__overlay"></div>
        <div class="qv__body">
        <button class="close-button qv__close" title="Close" aria-label="Close Quick View"></button>
        <div class="qv__body-inner"></div>
        </div>`;

    document.querySelector(".shopify-section--cart").parentElement.appendChild(qvParent);
    //document.body.appendChild(qvParent);
  }
 // qvParent.previousElement = document.activeElement || document.body;
  document.querySelector(".qv__close").focus();

  qvParent.classList.add("loading-animation", "quick-view__container--nudge");

  document.body.classList.add("modal-open");

  let promises = [];
  // if (typeof variantUpdateProcess == "undefined")
  //   promises.push(loadScript(scripts.variants));
  if (typeof pdpCreateSizeSelect == "undefined") {
    // promises.push(loadScript(scripts.pdp));
    // promises.push(loadStyle(styles.pdp));
    // promises.push(loadStyle(styles.pdpGallery));
    // promises.push(loadStyle(styles.starRating));
    // promises.push(loadStyle(styles.waitlist));
    // promises.push(loadStyle(styles.tooltip));
  }

  if (promises.length > 0) await Promise.all(promises);

  await getQuickViewProduct(link, variant).then((json) => {
    setQuickViewContent(json, variant, qvParent);
  });

  qvParent.classList.add("quick-view__container--active");
  qvParent.classList.remove(
      "loading-animation",
      "quick-view__container--nudge"
  );

  const qvButton = document.querySelectorAll(".qv__body .button--pdp__submit");
  [].map.call(qvButton, (button) => {
    button.classList.add("qv_add-to-cart");
  });
  // // Temp disable california check
  // calpak.updatePdpSwatchesForCalifornia();
}
calpak.getQuickView = getQuickView

window.addEventListener("click", async (e) => {
  if (
      e.target.classList.contains("qv__overlay") ||
      e.target.classList.contains("qv__close")
  ) {
    e.preventDefault();
    const qvContainer = document.querySelector(".quick-view__container");
    //const previousElement = qvContainer.previousElement;

    document.body.classList.remove("modal-open");
    qvContainer?.classList.remove("quick-view__container--active");

    if(calpak.quickViewTriggerElement){
      calpak.quickViewTriggerElement.focus();
    }

    setTimeout(() => {
      qvContainer?.remove();
   //   previousElement?.focus();
    }, 305);
  }
});